angular.module('edxComponents')
  .service('navigationTabsService', [
    '$state',
    'configuration',
    'authentication',
    'edxFeatureFlagService',
    'assignedFocusApi',
    'regmarkService',
    function (
      $state,
      $configuration,
      $authentication,
      featureFlagService,
      assignedFocusApi,
      regmarkService) {

      /** Holds the currently active/highlighted tab. */
      var _activeTab;

      /** Holds the currently visible tabs. */
      var _currentTabs;

      function setActiveTab(tab) {
        _activeTab = tab;
      }

      function getActiveTab() {
        return _activeTab;
      }

      function setCurrentTabs(tabs) {
        _currentTabs = tabs;
      }

      function getCurrentTabs() {
        return _currentTabs;
      }

      /** Sets the active tab given the slug */
      function setActiveTabBySlug(slug) {
        _activeTab = _.findWhere(_currentTabs, {slug: slug});
      }

      /****************************************************************************
       * Tab Factory functions
       *
       ****************************************************************************/
      var tabFactory = {};

      tabFactory.overview = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'overview'), title: (title ? title : 'Overview')};
      };

      tabFactory.standards = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'standards'), title: (title ? title : 'Standards')};
      };

      tabFactory.usage = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'usage'), title: (title ? title : 'Usage')};
      };

      tabFactory.activity = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'activity'), title: (title ? title : 'Activity')};
      };

      tabFactory.grades = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'grades'), title: (title ? title : 'Grades')};
      };

      tabFactory.schools = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'schools'), title: (title ? title : 'Schools')};
      };

      tabFactory.classes = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'classes'), title: (title ? title : 'Classes')};
      };

      tabFactory.students = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'students'), title: (title ? title : 'Students')};
      };

      tabFactory.teachers = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'teachers'), title: (title ? title : 'Teachers')};
      };

      tabFactory.performance = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'performance'), title: (title ? title : 'Performance')};
      };

      tabFactory.roster_ro = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'roster_ro'), title: (title ? title : 'Roster')};
      };

      tabFactory.create_assignment = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'create_assignment'), title: (title ? title : 'Topic or Standard')};
      };

      tabFactory.create_nwea_assignment = function (id, slug, title) {
         return {id: id, slug: (slug ? slug : 'create_nwea_assignment'), title: (title ? title : 'NWEA Score')};
      };

      tabFactory.create_quantile_assignment = function (id, slug, title) {
        return {id: id, slug: (slug ? slug : 'create_quantile_assignment'), title: (title ? title : 'Quantile'+ regmarkService.toString() + ' Framework')};
      };

      tabFactory.assignments = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'assignments'), title: (title ? title : 'Assignments')};
      };

      tabFactory.alerts = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'alerts'), title: (title ? title : 'Alerts')};
      };

      tabFactory.concepts = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'concepts'), title: (title ? title : 'Concepts')};
      };

      tabFactory.customers_usage = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'customers_usage'), title: (title ? title : 'Dashboard Usage')};
      };

      tabFactory.school_customers_usage = function (id, slug, title) {
          return {
              id: id,
              slug: (slug ? slug : 'school_customers_usage'),
              title: (title ? title : 'Dashboard Usage')
          };
      };

      tabFactory.curriculum = function (id, slug, title) {
          return {id: id, slug: (slug ? slug : 'curriculum'), title: (title ? title : 'Curriculum')};
      };

      tabFactory.buildList = function (tabNames) {
          var tabList = [];
          _.each(tabNames, function (tabName, index) {
              tabList.push(tabFactory[tabName](index));
          });
          return tabList;
      };

      tabFactory.addTabs = function (tabList, tabNames) {
          var newIndex = tabList.length;
          _.each(tabNames, function (tabName, index) {
              tabList.push(tabFactory[tabName](newIndex));
              newIndex++;
          });
          return tabList;
      };


      /****************************************************************************
       * Tab Functions
       *
       * Build up tabs for each level of the navigation hierarchy. Tab lists are
       * built up from the tab factories.
       *
       * The tab slug corresponds to the name of the partial in / right-pane / partials
       * You can override default tab values by doing the following:
       *
       * var customSettings = tabFactory.settings(0, 'custom-slug-here', 'This is a custom Title');
       * var anothercustomSetting = tabFactory.settings(1, 'another-slug-here' 'Custom Settings');
       * return [customSettings, anothercustomSetting];
       ****************************************************************************/

      var tabs = {};

      tabs.student = {
          default: function (params) {
              // Default tab list for all users
              var tabList = tabFactory.buildList(['overview', 'activity', 'standards']);

              var showAssignedLessons = false;
              var customer = $authentication.getCustomer();

              tabFactory.addTabs(tabList, ['usage']); //for all users

              if ($configuration.isFeatureEnabled('tab_concepts_enabled') &&
                  $authentication.canViewConceptsMap(customer)) {
                  tabFactory.addTabs(tabList, ['concepts']);
              }

              if ($authentication.canAssignLessons(customer)) {
                  showAssignedLessons = true;
              }

              if (showAssignedLessons) {
                  tabFactory.addTabs(tabList, ['assignments']);
              }

              return tabList;
          },
          assign: function () {
              return _buildAssignFocusTabs();
          }
      };

      tabs.school = {
          default: function (params) {
              params = params || $state.params;

              return (params.gradeId) ? tabFactory.buildList(['teachers', 'school_customers_usage']) : tabFactory.buildList(['teachers', 'grades', 'school_customers_usage']);
          }
      };

      tabs.grade = {
          default: function (params) {
              params = params || $state.params;

              return (params.schoolId) ? tabFactory.buildList(['teachers']) : tabFactory.buildList(['schools']);
          }
      };

      tabs.teacher = {
          default: function (params) {
              var tabList = tabFactory.buildList(['classes', 'students']);
              return tabList;
          }
      };

      tabs.district = {
          default: function () {
              return tabFactory.buildList(['schools', 'grades', 'performance', 'customers_usage']);
          }
      };

      tabs.classroom = {
          default: function () {
              var customer = $authentication.getCustomer();
              var tabList = tabFactory.buildList([]);

              // default overview tab
              tabFactory.addTabs(tabList, ['overview']);

              if(customer && customer.hasTag('INSIGHT_EFP') && $configuration.isFeatureEnabled('alerts_efp_enabled')) {
                tabFactory.addTabs(tabList, ['alerts']);
              }

              // other tabs visible to everyone
              tabFactory.addTabs(tabList, ['activity', 'standards', 'usage']);

              // if user is magneto managed but edit locked, show a read only roster
              var showRORoster = false;
              var showAssignedLessons = false;

              if ($configuration.isFeatureEnabled('tab_concepts_enabled') &&
                  $authentication.canViewConceptsMap(customer)) {
                  tabFactory.addTabs(tabList, ['concepts']);
              }
              if ($authentication.isMagnetoManaged(customer)) {
                  showRORoster = true;
              }
              if ($authentication.canAssignLessons(customer)) {
                  showAssignedLessons = true;
              }
              if (showAssignedLessons) {
                  tabFactory.addTabs(tabList, ['assignments']);
              }
              if (showRORoster) {
                  tabFactory.addTabs(tabList, ['roster_ro']);
              }

              return tabList;
          },
          assign: function () {
              return _buildAssignFocusTabs();
          }
      };

      tabs.guardian = {
          default: function () {
              // default list of tabs for everyone
              var tabList = tabFactory.buildList(['overview', 'activity', 'standards', 'usage', 'curriculum']);
              var customer = $authentication.getCustomer();

              if ($authentication.canAssignLessons(customer) && customer.user_af_enabled_list[$state.params.studentId]) {
                  tabFactory.addTabs(tabList, ['assignments']);
              }

              return tabList;
          },
          assign: function () {
              return tabFactory.buildList(['create_assignment']);
          }
      };

      /****************************************************************************
       * Accessor Functions
       *
       * Access list of tabs for a given state type i.e.( 'district', 'school', 'grade', etc), and
       * given state type i.e. (assign mode or default mode).
       *
       * Public getters for list / individual tab.
       *
       ****************************************************************************/

      /* If we are in assign mode and in a valid state return assign tabs
       * otherwise return default tabs
       * otherwise return empty list
       */
      function _getTabs(type, assign, params) {
          var tabList = [];
          if (assign === 'true' && tabs[type]) {
              tabList = tabs[type].assign();
          } else if (type && tabs[type]) {
              tabList = tabs[type].default(params);
          }
          return tabList;
      }

      /* If a tab is selected - a slug is provided to search for - then search
       * through current tabs - based off of type ('school', 'grade', etc)
       * and return selected tab.
       *
       * Otherwise return the first tab from the list
       */
      function _getTab(type, assign, slug, params) {
          var tabList = _getTabs(type, assign, params);
          if (slug) {
              return _.findWhere(tabList, {slug: slug});
          } else {
              return _.first(tabList);
          }
      }

      function getTabSlug(type, assign, params) {
          var tab = _getTab(type, assign, params.pane, params);
          return ( tab ) ? tab.slug : null;
      }

      function getTabs(type) {
          return _getTabs(type, $state.params.assign);
      }

      function getTab(type) {
          return _getTab(type, $state.params.assign, $state.params.pane);
      }

      function getLabel(assign) {
        // We take the assign parameter as hack to prevent the label from changing before the tabs themselves.
        // The caller passes in the value of $state.params.assign at the moment it last called getTabs().  Otherwise
        // sometimes the value of $state.params.assign will change and the label will update immediately but the
        // tabs do not get refreshed until the current "item" gets loaded.  A better fix would be to derive the type
        // directly from the state parameters instead of relying on the loaded "item" and refresh the tab list
        // immediately when that changes.  However, I'm not certain there are no cases that would break.
        if (assign === 'true') {
          return 'Add Assignment by:';
        } else {
          return '';
        }
      }

      return {
        getTab: getTab,
        getTabs: getTabs,
        getTabSlug: getTabSlug,
        getLabel: getLabel,
        setActiveTabBySlug: setActiveTabBySlug,
        set activeTab(tab) { setActiveTab(tab); },
        get activeTab() { return getActiveTab(); },
        set currentTabs(tabs) { setCurrentTabs(tabs); },
        get currentTabs() { return getCurrentTabs(); }
      };

      function _buildAssignFocusTabs() {
          if ($configuration.isFeatureEnabled('dbl_lite')) {
              return tabFactory.buildList([]);
          }

          var customer = $authentication.getCustomer();
          var tabList = tabFactory.buildList([]);

          // default create assignment tab
          tabFactory.addTabs(tabList, ['create_assignment']);

          if (customer && !$state.params.groupId) {
              assignedFocusApi.getActiveThirdPartyAssessment().then(function(assessment){
                  if (featureFlagService.isNweaEnabled(customer) && assessment.value && assessment.value.toLowerCase().indexOf('nwea') >= 0) {
                      tabFactory.addTabs(tabList, ['create_nwea_assignment']);
                  }

                  if (assessment.value && assessment.value.toLowerCase().indexOf('quantile') >= 0) {
                      tabFactory.addTabs(tabList, ['create_quantile_assignment']);
                  }
              });
          }
          return tabList;
      }
  }]);

